import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { AccumulatorService } from '../service/accumulator.service';

@Injectable({
    providedIn: 'root'
})
export class AccumulatorValidators
{
    constructor(private accumulatorService: AccumulatorService) { }

    public validateAccumulatorNameUnique(control: UntypedFormControl, initialName: string): any
    {
        return new Promise(resolve =>
        {
            if (control !== null && initialName !== control.value)
            {
                this.accumulatorService.existsAccumulatorName(control.value).subscribe({
                    next: (response) =>
                    {
                        if (response)
                        {
                            resolve({ nameExists: true });
                        }
                        else
                        {
                            resolve(null);
                        }
                    }
                });
            }
            else
            {
                resolve(null);
            }
        });
    }
}
